import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 语言资源文件，例如英语和西班牙语
import en from "./lang/en.json";
import cn from "./lang/cn.json";

const resources = {
  en: {
    translation: en,
  },
  cn: {
    translation: cn,
  },
};

const local = localStorage?.getItem("local")!;
i18n
  .use(initReactI18next) // 使用 react-i18next 初始化
  .init({
    resources, // 语言资源
    lng: local ? local : "en", // 默认语言
    // keySeparator: false, // 键分隔符，默认为'.'
    interpolation: {
      escapeValue: false, // 是否转义值
    },
  });

export default i18n;
